import { useContext } from 'react'
import FeatureFlagContext from 'lib/feature-flags/FeatureFlagContext'
import { flags } from 'lib/feature-flags/constants'

const STORAGE_KEY = 'pga-guest-private-booking'

// Missing Flagr keys stay off. useFeatureFlags reports those to Raygun, which
// would fire on every schedule view until the flag exists.
export const useGuestPrivateBookingEnabled = () => {
  const featureFlags = useContext(FeatureFlagContext) || {}
  return featureFlags[flags.FLAG_FEAT_GUEST_PRIVATE_BOOKING] === true
}

export const saveGuestBooking = booking => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(booking))
}

export const loadGuestBooking = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const clearGuestBooking = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}

export const withGuestBookingParam = currentUrl => {
  const [path, search = ''] = currentUrl.split('?')
  const params = new URLSearchParams(search)
  params.set('guestBooking', '1')
  const nextSearch = params.toString()
  return nextSearch ? `${path}?${nextSearch}` : path
}

export const digitsOnly = value => (value || '').replace(/\D/g, '')
